export default __webpack_public_path__ + "static/media/shoes1-afterA-1440w.0e3f5332.avif";